"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    rpc: {},
    types: {
        OrmlVestingSchedule: {
            token: 'FungibleTokenId',
            start: 'BlockNumber',
            period: 'BlockNumber',
            periodCount: 'u32',
            perPeriod: 'Balance'
        },
        VestingScheduleOf: 'OrmlVestingSchedule'
    }
};
